import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Outlet, Link } from "react-router-dom";

import './App.css';
import profile from './imgs/profile.jpg';


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="research" element={<Research />} />
          <Route path="software" element={<Software />} />
          <Route path="*" element={<NoMatch />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function Layout() {
  const [currentPage, setCurrentPage] = useState('home');

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div>
      <nav className="navbar">
        <Link to="/" className={currentPage === 'home' ? 'active' : ''} onClick={() => handlePageChange('home')}>Home</Link>
        <Link to="/research" className={currentPage === 'research' ? 'active' : ''} onClick={() => handlePageChange('research')}>Research</Link>
        <Link to="/software" className={currentPage === 'software' ? 'active' : ''} onClick={() => handlePageChange('software')}>Software</Link>
      </nav>
      <Outlet />
    </div>
  );
}

function Home() {
  return (
    <div className="main-content">
      <div className="intro-content">
        <h1>Hi, I am Dr. David Grant</h1>
        <p>
          As a postdoc in astrophysics at the <a href="https://www.bristol.ac.uk/physics/research/astrophysics/" target="_blank">University of Bristol</a>,
          I conduct research into the atmospheres of exoplanets
          using space telescopes such as <a href="https://science.nasa.gov/mission/webb/" target="_blank">JWST</a>.
        </p>
      </div>
      <div className="intro-content img-content">
        <img src={profile} />
      </div>
    </div>
  );
}

function Research() {
  return (
    <div className="main-content">
      <div className="research-content">
        <h2>Quartz Clouds in the Atmosphere of WASP-17b</h2>
        <p>
          <a href="https://iopscience.iop.org/article/10.3847/2041-8213/acfc3b" target="_blank"><strong>Grant D.</strong>, Lewis N. K., Wakeford H. R., et al., ApJ Letters, 2023, 956, L29</a>.
        </p>
        <h2>Identification of carbon dioxide in an exoplanet atmosphere</h2>
        <p>
          <a href="https://www.nature.com/articles/s41586-022-05269-w" target="_blank">JWST ERS Team, ..., <strong>Grant D.</strong>, et al., Nature, 2023, 614, 649</a>.
        </p>
        <h2>Transmission strings: a technique for spatially mapping exoplanet atmospheres around their terminators</h2>
        <p>
          <a href="https://doi.org/10.1093/mnras/stac3632" target="_blank"><strong>Grant D.</strong> and Wakeford H., MNRAS, 2023, 519, 5114</a>.
        </p>
        <h2></h2>
        <p>
          Above are a few research highlights. A complete bibliography is available at <a href="https://ui.adsabs.harvard.edu/search/fl=identifier%2C%5Bcitations%5D%2Cabstract%2Cauthor%2Cbook_author%2Corcid_pub%2Corcid_user%2Corcid_other%2Cbibcode%2Ccitation_count%2Ccomment%2Cdoi%2Cid%2Ckeyword%2Cpage%2Cproperty%2Cpub%2Cpub_raw%2Cpubdate%2Cpubnote%2Cread_count%2Ctitle%2Cvolume%2Clinks_data%2Cesources%2Cdata%2Ccitation_count_norm%2Cemail%2Cdoctype&fq=%7B!type%3Daqp%20v%3D%24fq_database%7D&fq_database=(database%3Aastronomy%20OR%20database%3Aphysics)&q=(author%3A%22Grant%2C%20David%22%20AND%20(aff%3A%22Oxford%22%20OR%20aff%3A%22Bristol%22))%20AND%20NOT%20(title%3A%22Neutrino%22%20OR%20title%3A%22Muon%22%20OR%20title%3A%22IceCube%22%20OR%20title%3A%22IceTop%22%20OR%20title%3A%22IceAct%22%20OR%20title%3A%22DEAP%22)%20AND%20year%3A2020-2100&rows=25&sort=date%20desc%2C%20bibcode%20desc&start=0&p_=0" target="_blank">ADS</a>.
        </p>
      </div>
    </div>
  );
}

function Software() {
  return (
    <div className="main-content">
      <div className="software-content">
        <h2>harmonica</h2>
        <p>
          Light curves for exoplanet transmission mapping |
          <a className="software-link" href="https://github.com/DavoGrant/harmonica" target="_blank">code</a>|
          <a className="software-link" href="http://harmonica.readthedocs.io/" target="_blank">docs</a>|
          <a className="software-link" href="https://doi.org/10.1093/mnras/stac3632" target="_blank">citation</a>
        </p>
        <h2>ExoTiC-LD</h2>
        <p>
          Calculate stellar limb-darkening coefficients |
          <a className="software-link" href="https://github.com/Exo-TiC/ExoTiC-LD" target="_blank">code</a>|
          <a className="software-link" href="https://exotic-ld.readthedocs.io/" target="_blank">docs</a>|
          <a className="software-link" href="https://exotic-ld.readthedocs.io/en/latest/views/citation.html" target="_blank">citation</a>
        </p>
        <h2>ExoTiC-MIRI</h2>
        <p>
          A custom and interoperable JWST MIRI pipeline |
          <a className="software-link" href="https://github.com/Exo-TiC/ExoTiC-MIRI" target="_blank">code</a>|
          <a className="software-link" href="https://exotic-miri.readthedocs.io/" target="_blank">docs</a>|
          <a className="software-link" href="https://exotic-miri.readthedocs.io/en/latest/views/citation.html" target="_blank">citation</a>
        </p>
        <h2></h2>
        <p>
          More of my open-source software can be found on <a href="https://github.com/DavoGrant" target="_blank">GitHub</a>.
        </p>
      </div>
    </div>
  );
}

function NoMatch() {
  return (
    <div className="main-content">
      <div className="sub-content">
          <p>...</p>
      </div>
    </div>
  );
}



